import { useEffect, useState } from "react";
import Svg from "../components/figs/Svg";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import Loading from "../components/Loading";
import { useAlertModal } from "../hooks/useAlertModal";
import { fetchPost, setStaticData } from "../functions/functions";
import api from "../routes/api";

import {
  onAuthStateChanged,
  signInWithCredential,
  signInWithCustomToken,
  signInWithEmailAndPassword,
} from "firebase/auth";
import {
  firebaseGetAuth,
  firebaseGetFileUrl,
  uploadImageBase64,
} from "../services/firebase";
import { base64 } from "../consts/base64";

export default function Auth() {
  const [isLoading, setIsLoading] = useState(false);
  const { msg } = useSelector((state) => state.language);
  const { alert, AlertModal } = useAlertModal();

  const loc = useLocation();
  const searchParams = new URLSearchParams(loc.search);
  const resetPassword = searchParams.get("resetPassword");

  const navigate = useNavigate();
  const [formType, setFormType] = useState(
    resetPassword === "true" ? "reset" : "signin"
  );
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSignin = async (data) => {
    try {
      setIsLoading(true);
      const payload = {
        email: data.email,
        password: data.password,
      };
      const result = await fetchPost(api.auth.signin, null, payload);
      if (result.status === "error") throw result;
      localStorage.setItem("auth", JSON.stringify(result));
      localStorage.setItem("token", result.data.token);

      const customTokenFromBackend = result.data?.customToken;
      localStorage.setItem("customToken", customTokenFromBackend);

      const firebaseAuth = firebaseGetAuth();

      if (customTokenFromBackend) {
        await signInWithCustomToken(firebaseAuth, customTokenFromBackend);
      }

      const staticData = await setStaticData();
      if (staticData.staticDataStatus && result.auth) {
        setIsLoading(false);
        navigate("/welcome");
      }
    } catch (error) {
      console.error(error);
      alert(msg.alert, error.msg || msg.try_again);
    } finally {
      setIsLoading(false);
    }
  };
  const onSubmitForget = async (data) => {
    try {
      setIsLoading(true);
      const payload = {
        email: data.email,
      };
      const result = await fetchPost(api.auth.forgetPassword, null, payload);
      if (result.status === "error") throw result;
      alert(msg.reset_password, msg.check_your_email);
      reset();
      setFormType("signin");
    } catch (error) {
      console.error(error);
      alert(msg.alert, error.msg || msg.try_again);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <div className="page_auth">
        <div className="_main_bg"></div>
        <div className="logo_app">
          <Svg iconName="logo" />
        </div>
        {formType === "signin" && (
          <div className="signin">
            <h1>{msg.sign_in}</h1>
            <p>{msg.welcome_to_inverz_agent_marine}</p>
            <form className="form">
              <input
                type="email"
                placeholder={msg.username}
                {...register("email", { required: true })}
                className={errors.email && "_data_invalid"}
              />
              <input
                type="password"
                placeholder={msg.password}
                {...register("password", { required: true })}
                className={errors.password && "_data_invalid"}
              />
              <button onClick={handleSubmit(onSignin)} type="submit">
                {msg.sign_in}
              </button>
            </form>
          </div>
        )}
        {formType === "reset" && (
          <div className="signin">
            <h1 className="mini">{msg.reset_password}</h1>
            <p>{msg.welcome_to_inverz_agent_marine}</p>
            <form className="form">
              <input
                type="email"
                placeholder={msg.email}
                {...register("email", { required: true })}
                className={errors.email && "_data_invalid"}
              />
              <button onClick={handleSubmit(onSubmitForget)} type="submit">
                {msg.submit}
              </button>
            </form>
          </div>
        )}
        <div className="section_below_of_form">
          {formType === "signin" && (
            <p>
              {msg.forget_your_password}
              <Link onClick={() => setFormType("reset")}>
                {msg.reset_password}
              </Link>
            </p>
          )}
          {formType === "reset" && (
            <p>
              <Link onClick={() => setFormType("signin")}>{msg.sign_in}</Link>
            </p>
          )}
        </div>
        {isLoading && <Loading />}
      </div>
      {AlertModal}
    </>
  );
}
